import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
`

export const Wrapper = styled.div<{ isBigMenu: boolean }>`
  width: 100%;
  /* min-width:0 permite o conteudo (ex.: tabelas largas) encolher e rolar internamente em vez de
     esticar a area de conteudo e estourar a pagina (padrao de item flex e min-width:auto). */
  min-width: 0;
  margin-left: ${({ isBigMenu }) => (isBigMenu ? '200px' : '100px')};
  padding: 110px 25px;
`
